// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__232sr","title":"Info_title__1mfLd","links":"Info_links__1ykiu","link":"Info_link__2JEJu","logo":"Info_logo__g9fJu"};